import { render, staticRenderFns } from "./matricula-listado.vue?vue&type=template&id=0ce5367c&"
import script from "./matricula-listado.component.ts?vue&type=script&lang=ts&"
export * from "./matricula-listado.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports